import { Card, CardContent, Typography, Stack, Box } from '@mui/material';
import React from 'react';

import AppStatusChip from '../../buttons/AppStatusChip';

class StatCard extends React.Component {
  render() {
    const { CardContentObject: CardContentComponent, headerActions, footnote, trend } = this.props;

    const trendValues = { up: 'Increasing', down: 'Decreasing', stable: 'Stable' };
    const trendVariants = { up: 'success', down: 'danger', stable: 'neutral' };

    // La chip trend è opzionale: con `trend={null}` (o valore non mappato) la
    // card mostra solo il valore — utile per metriche "neutre" (es. KPI con
    // formula al posto del trend).
    const showTrend = !!trendVariants[trend];

    return (
      <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
        <CardContent>
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography component="h4">{this.props.title}</Typography>
            {headerActions && (
              <Stack direction="row" spacing={1}>
                {headerActions.map((ActionComponent, index) => (
                  <Box key={index}>{ActionComponent}</Box>
                ))}
              </Stack>
            )}
          </Stack>
          <Stack direction="column" sx={{ justifyContent: 'space-between', flexGrow: 1 }}>
            <Stack sx={{ justifyContent: 'space-between' }}>
              <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" component="p">
                  {this.props.value}
                </Typography>
                {showTrend && (
                  <AppStatusChip
                    fullCell={false}
                    variant={trendVariants[trend]}
                    label={trendValues[trend]}
                  />
                )}
              </Stack>
              {this.props.interval && (
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                  {this.props.interval}
                </Typography>
              )}
              {footnote && (
                <Typography
                  variant="caption"
                  component="div"
                  sx={{ color: 'text.secondary', mt: 0.5 }}
                >
                  {footnote}
                </Typography>
              )}
            </Stack>
            {CardContentComponent && typeof CardContentComponent === 'function' && (
              <Box sx={{ mt: 2 }}>
                <div style={{ height: this.props.graphHeight }}>
                  <CardContentComponent {...this.props} />
                </div>
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

StatCard.defaultProps = {
  title: 'Statistic Card',
  value: 'N/A',
  trend: 'stable',
  interval: 'This week',
  data: [],
  daysInWeek: [],
  chartColor: '#000000',
  CardContentObject: null, // Default to null
  headerActions: null, // Default to null
};

export default StatCard;
